module.exports = __webpack_public_path__ + "static/img/level-card-banner1.dde9fa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/2/level-card-banner1.png
// module id = xCn7
// module chunks = 1